// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-detail-page { min-height:100vh; background:var(--color-bg); }
.hero { background:var(--color-surface); border-radius:24px; overflow:hidden; margin:18px 0 22px; box-shadow:var(--shadow-md); border:1px solid var(--color-border); position:relative; animation:fadeSlideUp .6s both; }
.hero img { width:100%; height:auto; display:block; aspect-ratio:16/9; object-fit:cover; filter:brightness(.97); transition:var(--transition-base); }
.hero:hover img { transform:scale(1.02); filter:brightness(1.03); }
.hero-meta { padding:16px 20px 18px; display:flex; flex-direction:column; gap:12px; background:linear-gradient(180deg,rgba(99,102,241,.08),rgba(255,255,255,0)); }

/* 标题行包含服务名称和收藏按钮 */
.hero-title-row { display:flex; justify-content:space-between; align-items:center; width:100%; gap:16px; }
.hero-meta h2 { margin:0; font-size:1.2rem; color:var(--color-text); font-weight:700; letter-spacing:.5px; flex:1 1; }

/* 服务详情页收藏按钮 */
.favorite-btn-detail {
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.2rem;
  transition: var(--transition-base);
  backdrop-filter: blur(4px);
  box-shadow: var(--shadow-sm);
  flex-shrink: 0;
}

.favorite-btn-detail:hover {
  background: rgba(255, 255, 255, 1);
  transform: scale(1.1);
  box-shadow: var(--shadow-md);
}

.favorite-btn-detail.favorited {
  background: rgba(255, 182, 193, 0.9);
}

.favorite-btn-detail.favorited:hover {
  background: rgba(255, 182, 193, 1);
}
.price { margin:0; color:var(--color-danger); font-size:1.05rem; font-weight:700; white-space:nowrap; }

.section { background:var(--color-surface); border-radius:22px; padding:20px 20px 22px; margin:0 0 22px; box-shadow:var(--shadow-sm); border:1px solid var(--color-border); animation:fadeSlideUp .6s both; }
.section h3 { margin:0 0 14px; color:var(--color-text); font-size:1rem; letter-spacing:.4px; }
.desc { color:var(--color-text-sec); line-height:1.7; font-size:.85rem; }

.tag-list { display:flex; flex-wrap:wrap; gap:10px; margin:0; padding:0; list-style:none; }
.tag { background:linear-gradient(135deg,rgba(99,102,241,.12),rgba(99,102,241,.05)); color:var(--color-primary-accent); border:1px solid rgba(99,102,241,.25); padding:6px 12px; border-radius:18px; font-size:.7rem; font-weight:600; letter-spacing:.5px; backdrop-filter:blur(4px); }

.bullet-list { margin:0; padding-left:20px; color:var(--color-text-sec); line-height:1.6; font-size:.8rem; }
.bullet-list li { padding:2px 0; }
.notes { background:linear-gradient(120deg,#f8fafc,rgba(99,102,241,.08)); border-left:4px solid var(--color-primary); padding:12px 14px; border-radius:12px; color:var(--color-text-sec); font-size:.8rem; }

.detail-footer { position:sticky; bottom:0; background:rgba(255,255,255,.9); backdrop-filter:saturate(180%) blur(10px); border-top:1px solid var(--color-border); padding:12px 18px; box-shadow:0 -2px 8px rgba(0,0,0,.08); display:flex; justify-content:space-between; align-items:center; gap:12px; }
.footer-info { display:flex; gap:14px; align-items:baseline; flex-shrink:0; }
.footer-price { color:var(--color-danger); font-size:1.25rem; font-weight:800; letter-spacing:.5px; }
.footer-duration { color:var(--color-muted); font-size:.65rem; font-weight:500; letter-spacing:1px; text-transform:uppercase; }
.book-now { padding:12px 22px; border-radius:16px; font-size:.95rem; white-space:nowrap; flex-shrink:0; margin-left:auto; }

.not-found { padding:40px 0; color:var(--color-text-sec); text-align:center; }

@media (max-width:560px) {
	.hero-meta { gap:10px; }
	.hero-title-row { gap:12px; }
	.hero-meta h2 { font-size:1.05rem; }
	.favorite-btn-detail { width:36px; height:36px; font-size:1.1rem; }
	.price { font-size:1rem; }
	.detail-footer { padding:10px 12px; gap:8px; }
	.footer-info { gap:8px; }
	.footer-price { font-size:1.1rem; }
	.footer-duration { font-size:0.6rem; }
	.book-now { padding:10px 16px; font-size:0.85rem; min-width:80px; }
}

@media (max-width:420px) {
	.detail-footer { padding:8px 10px; }
	.footer-info { flex-direction:column; gap:2px; align-items:flex-start; }
	.footer-price { font-size:1rem; }
	.footer-duration { font-size:0.55rem; }
	.book-now { padding:8px 12px; font-size:0.8rem; min-width:70px; }
}

@media (max-width: 360px) {
  /* 页面整体优化 */
  .service-detail-page {
    padding-bottom: 20px; /* 移除底部导航栏空间，详情页面不显示导航栏 */
  }

  /* 头部区域优化 */
  .hero {
    padding: 16px 14px 18px;
    margin: 10px 0 12px;
    border-radius: 14px;
  }

  .hero-image {
    height: 160px; /* 减少图片高度 */
    border-radius: 12px;
  }

  .hero-meta {
    padding: 14px 0 0;
  }

  .hero-meta h2 {
    font-size: 1rem;
    margin-bottom: 6px;
  }

  .price {
    font-size: 0.9rem;
  }

  /* 内容区域优化 */
  .content {
    padding: 16px 14px;
    margin: 10px 0;
    border-radius: 14px;
  }

  .content h3 {
    font-size: 0.95rem;
    margin-bottom: 10px;
  }

  .content p, .content li {
    font-size: 0.8rem;
    line-height: 1.5;
  }

  /* 底部操作栏优化 */
  .detail-footer {
    padding: 10px 12px;
    height: 60px;
  }

  .footer-info {
    flex-direction: column;
    gap: 2px;
    align-items: flex-start;
  }

  .footer-price {
    font-size: 1rem;
  }

  .footer-duration {
    font-size: 0.6rem;
  }

  .book-now {
    padding: 10px 14px;
    font-size: 0.8rem;
    min-width: 70px;
    min-height: 40px;
    border-radius: 10px;
  }
}

/* 极小屏幕优化 (≤320px) */
@media (max-width: 320px) {
  .hero {
    padding: 14px 12px 16px;
    margin: 8px 0 10px;
  }

  .hero-image {
    height: 140px;
  }

  .hero-meta h2 {
    font-size: 0.9rem;
  }

  .price {
    font-size: 0.85rem;
  }

  .content {
    padding: 14px 12px;
  }

  .content h3 {
    font-size: 0.9rem;
  }

  .content p, .content li {
    font-size: 0.75rem;
  }

  .detail-footer {
    padding: 8px 10px;
    height: 56px;
  }

  .footer-price {
    font-size: 0.9rem;
  }

  .footer-duration {
    font-size: 0.55rem;
  }

  .book-now {
    padding: 8px 12px;
    font-size: 0.75rem;
    min-width: 60px;
    min-height: 36px;
  }
}

/* 预约弹窗样式 */
.modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	padding: 20px;
	animation: fadeIn 0.3s ease-out;
}

.booking-modal {
	background: var(--color-surface);
	border-radius: 20px;
	box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
	width: 100%;
	max-width: 480px;
	max-height: 90vh;
	overflow-y: auto;
	animation: slideUp 0.3s ease-out;
}

.modal-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px 20px 0;
	border-bottom: 1px solid var(--color-border);
	margin-bottom: 20px;
}

.modal-header h3 {
	margin: 0;
	color: var(--color-text);
	font-size: 1.1rem;
	font-weight: 600;
}

.close-btn {
	background: none;
	border: none;
	font-size: 24px;
	color: var(--color-muted);
	cursor: pointer;
	padding: 0;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	transition: all 0.2s;
}

.close-btn:hover {
	background: var(--color-surface-alt);
	color: var(--color-text);
}

.modal-body {
	padding: 0 20px 20px;
}

.form-group {
	margin-bottom: 16px;
}

.form-group label {
	display: block;
	margin-bottom: 6px;
	color: var(--color-text);
	font-size: 0.9rem;
	font-weight: 500;
}

.form-group input,
.form-group textarea {
	width: 100%;
	padding: 12px 14px;
	border: 1px solid var(--color-border);
	border-radius: 12px;
	font-size: 0.9rem;
	color: var(--color-text);
	background: var(--color-bg);
	transition: all 0.2s;
	box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
	outline: none;
	border-color: var(--color-primary);
	box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.form-group input:disabled {
	background: var(--color-surface-alt);
	color: var(--color-muted);
	cursor: not-allowed;
	opacity: 0.6;
}

.form-group textarea {
	resize: vertical;
	min-height: 80px;
}

.form-group input.error,
.form-group textarea.error {
	border-color: var(--color-danger);
}

.error-text {
	display: block;
	color: var(--color-danger);
	font-size: 0.75rem;
	margin-top: 4px;
}

.time-hint {
	display: block;
	color: var(--color-muted);
	font-size: 0.75rem;
	margin-top: 4px;
	font-style: italic;
}

.form-row {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 12px;
}

.modal-footer {
	display: flex;
	gap: 12px;
	padding: 20px;
	border-top: 1px solid var(--color-border);
}

.cancel-btn,
.confirm-btn {
	flex: 1 1;
	padding: 12px 20px;
	border: none;
	border-radius: 12px;
	font-size: 0.9rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s;
}

.cancel-btn {
	background: var(--color-surface-alt);
	color: var(--color-text-sec);
	border: 1px solid var(--color-border);
}

.cancel-btn:hover {
	background: var(--color-border);
	color: var(--color-text);
}

.confirm-btn {
	background: var(--color-primary);
	color: white;
}

.confirm-btn:hover {
	background: var(--color-primary-accent);
}

@keyframes fadeIn {
	from { opacity: 0; }
	to { opacity: 1; }
}

@keyframes slideUp {
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@media (max-width: 480px) {
	.modal-overlay {
		padding: 10px;
	}
	
	.booking-modal {
		max-height: 95vh;
	}
	
	.form-row {
		grid-template-columns: 1fr;
	}
	
	.modal-header,
	.modal-body,
	.modal-footer {
		padding-left: 16px;
		padding-right: 16px;
	}
}

`, "",{"version":3,"sources":["webpack://./src/components/ServiceDetailPage.css"],"names":[],"mappings":"AAAA,uBAAuB,gBAAgB,EAAE,0BAA0B,EAAE;AACrE,QAAQ,+BAA+B,EAAE,kBAAkB,EAAE,eAAe,EAAE,kBAAkB,EAAE,2BAA2B,EAAE,oCAAoC,EAAE,iBAAiB,EAAE,8BAA8B,EAAE;AACxN,YAAY,UAAU,EAAE,WAAW,EAAE,aAAa,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,iCAAiC,EAAE;AACpJ,kBAAkB,qBAAqB,EAAE,uBAAuB,EAAE;AAClE,aAAa,sBAAsB,EAAE,YAAY,EAAE,qBAAqB,EAAE,QAAQ,EAAE,2EAA2E,EAAE;;AAEjK,mBAAmB;AACnB,kBAAkB,YAAY,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,UAAU,EAAE,QAAQ,EAAE;AACzG,gBAAgB,QAAQ,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,eAAe,EAAE,mBAAmB,EAAE,QAAM,EAAE;;AAEnH,cAAc;AACd;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,0BAA0B;EAC1B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;AACA,SAAS,QAAQ,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAEtG,WAAW,+BAA+B,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,eAAe,EAAE,2BAA2B,EAAE,oCAAoC,EAAE,8BAA8B,EAAE;AAC5M,cAAc,eAAe,EAAE,uBAAuB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC7F,QAAQ,2BAA2B,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAExE,YAAY,YAAY,EAAE,cAAc,EAAE,QAAQ,EAAE,QAAQ,EAAE,SAAS,EAAE,eAAe,EAAE;AAC1F,OAAO,4EAA4E,EAAE,iCAAiC,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE,mBAAmB,EAAE,yBAAyB,EAAE;;AAEvR,eAAe,QAAQ,EAAE,iBAAiB,EAAE,2BAA2B,EAAE,eAAe,EAAE,eAAe,EAAE;AAC3G,kBAAkB,aAAa,EAAE;AACjC,SAAS,+DAA+D,EAAE,0CAA0C,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,2BAA2B,EAAE,eAAe,EAAE;;AAE3M,iBAAiB,eAAe,EAAE,QAAQ,EAAE,+BAA+B,EAAE,yCAAyC,EAAE,wCAAwC,EAAE,iBAAiB,EAAE,qCAAqC,EAAE,YAAY,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,QAAQ,EAAE;AACvS,eAAe,YAAY,EAAE,QAAQ,EAAE,oBAAoB,EAAE,aAAa,EAAE;AAC5E,gBAAgB,yBAAyB,EAAE,iBAAiB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACpG,mBAAmB,wBAAwB,EAAE,gBAAgB,EAAE,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE;AAC9H,YAAY,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,aAAa,EAAE,gBAAgB,EAAE;;AAE1H,aAAa,cAAc,EAAE,2BAA2B,EAAE,iBAAiB,EAAE;;AAE7E;CACC,aAAa,QAAQ,EAAE;CACvB,kBAAkB,QAAQ,EAAE;CAC5B,gBAAgB,iBAAiB,EAAE;CACnC,uBAAuB,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE;CAClE,SAAS,cAAc,EAAE;CACzB,iBAAiB,iBAAiB,EAAE,OAAO,EAAE;CAC7C,eAAe,OAAO,EAAE;CACxB,gBAAgB,gBAAgB,EAAE;CAClC,mBAAmB,gBAAgB,EAAE;CACrC,YAAY,iBAAiB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACnE;;AAEA;CACC,iBAAiB,gBAAgB,EAAE;CACnC,eAAe,qBAAqB,EAAE,OAAO,EAAE,sBAAsB,EAAE;CACvE,gBAAgB,cAAc,EAAE;CAChC,mBAAmB,iBAAiB,EAAE;CACtC,YAAY,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACjE;;AAEA;EACE,WAAW;EACX;IACE,oBAAoB,EAAE,yBAAyB;EACjD;;EAEA,WAAW;EACX;IACE,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa,EAAE,WAAW;IAC1B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,WAAW;EACX;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,YAAY;EACZ;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,WAAW;AACX;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,8BAA8B;CAC9B,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,aAAa;CACb,aAAa;CACb,+BAA+B;AAChC;;AAEA;CACC,gCAAgC;CAChC,mBAAmB;CACnB,2CAA2C;CAC3C,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,oBAAoB;CACpB,4CAA4C;CAC5C,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,wBAAwB;CACxB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,eAAe;CACf,yBAAyB;CACzB,eAAe;CACf,UAAU;CACV,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,oCAAoC;CACpC,wBAAwB;AACzB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,wBAAwB;CACxB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;;CAEC,WAAW;CACX,kBAAkB;CAClB,qCAAqC;CACrC,mBAAmB;CACnB,iBAAiB;CACjB,wBAAwB;CACxB,2BAA2B;CAC3B,oBAAoB;CACpB,sBAAsB;AACvB;;AAEA;;CAEC,aAAa;CACb,kCAAkC;CAClC,6CAA6C;AAC9C;;AAEA;CACC,oCAAoC;CACpC,yBAAyB;CACzB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;;CAEC,iCAAiC;AAClC;;AAEA;CACC,cAAc;CACd,0BAA0B;CAC1B,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,aAAa;CACb,SAAS;CACT,aAAa;CACb,yCAAyC;AAC1C;;AAEA;;CAEC,SAAO;CACP,kBAAkB;CAClB,YAAY;CACZ,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,oBAAoB;AACrB;;AAEA;CACC,oCAAoC;CACpC,4BAA4B;CAC5B,qCAAqC;AACtC;;AAEA;CACC,+BAA+B;CAC/B,wBAAwB;AACzB;;AAEA;CACC,gCAAgC;CAChC,YAAY;AACb;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,OAAO,UAAU,EAAE;CACnB,KAAK,UAAU,EAAE;AAClB;;AAEA;CACC;EACC,UAAU;EACV,2BAA2B;CAC5B;CACA;EACC,UAAU;EACV,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;;;EAGC,kBAAkB;EAClB,mBAAmB;CACpB;AACD","sourcesContent":[".service-detail-page { min-height:100vh; background:var(--color-bg); }\n.hero { background:var(--color-surface); border-radius:24px; overflow:hidden; margin:18px 0 22px; box-shadow:var(--shadow-md); border:1px solid var(--color-border); position:relative; animation:fadeSlideUp .6s both; }\n.hero img { width:100%; height:auto; display:block; aspect-ratio:16/9; object-fit:cover; filter:brightness(.97); transition:var(--transition-base); }\n.hero:hover img { transform:scale(1.02); filter:brightness(1.03); }\n.hero-meta { padding:16px 20px 18px; display:flex; flex-direction:column; gap:12px; background:linear-gradient(180deg,rgba(99,102,241,.08),rgba(255,255,255,0)); }\n\n/* 标题行包含服务名称和收藏按钮 */\n.hero-title-row { display:flex; justify-content:space-between; align-items:center; width:100%; gap:16px; }\n.hero-meta h2 { margin:0; font-size:1.2rem; color:var(--color-text); font-weight:700; letter-spacing:.5px; flex:1; }\n\n/* 服务详情页收藏按钮 */\n.favorite-btn-detail {\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 1.2rem;\n  transition: var(--transition-base);\n  backdrop-filter: blur(4px);\n  box-shadow: var(--shadow-sm);\n  flex-shrink: 0;\n}\n\n.favorite-btn-detail:hover {\n  background: rgba(255, 255, 255, 1);\n  transform: scale(1.1);\n  box-shadow: var(--shadow-md);\n}\n\n.favorite-btn-detail.favorited {\n  background: rgba(255, 182, 193, 0.9);\n}\n\n.favorite-btn-detail.favorited:hover {\n  background: rgba(255, 182, 193, 1);\n}\n.price { margin:0; color:var(--color-danger); font-size:1.05rem; font-weight:700; white-space:nowrap; }\n\n.section { background:var(--color-surface); border-radius:22px; padding:20px 20px 22px; margin:0 0 22px; box-shadow:var(--shadow-sm); border:1px solid var(--color-border); animation:fadeSlideUp .6s both; }\n.section h3 { margin:0 0 14px; color:var(--color-text); font-size:1rem; letter-spacing:.4px; }\n.desc { color:var(--color-text-sec); line-height:1.7; font-size:.85rem; }\n\n.tag-list { display:flex; flex-wrap:wrap; gap:10px; margin:0; padding:0; list-style:none; }\n.tag { background:linear-gradient(135deg,rgba(99,102,241,.12),rgba(99,102,241,.05)); color:var(--color-primary-accent); border:1px solid rgba(99,102,241,.25); padding:6px 12px; border-radius:18px; font-size:.7rem; font-weight:600; letter-spacing:.5px; backdrop-filter:blur(4px); }\n\n.bullet-list { margin:0; padding-left:20px; color:var(--color-text-sec); line-height:1.6; font-size:.8rem; }\n.bullet-list li { padding:2px 0; }\n.notes { background:linear-gradient(120deg,#f8fafc,rgba(99,102,241,.08)); border-left:4px solid var(--color-primary); padding:12px 14px; border-radius:12px; color:var(--color-text-sec); font-size:.8rem; }\n\n.detail-footer { position:sticky; bottom:0; background:rgba(255,255,255,.9); backdrop-filter:saturate(180%) blur(10px); border-top:1px solid var(--color-border); padding:12px 18px; box-shadow:0 -2px 8px rgba(0,0,0,.08); display:flex; justify-content:space-between; align-items:center; gap:12px; }\n.footer-info { display:flex; gap:14px; align-items:baseline; flex-shrink:0; }\n.footer-price { color:var(--color-danger); font-size:1.25rem; font-weight:800; letter-spacing:.5px; }\n.footer-duration { color:var(--color-muted); font-size:.65rem; font-weight:500; letter-spacing:1px; text-transform:uppercase; }\n.book-now { padding:12px 22px; border-radius:16px; font-size:.95rem; white-space:nowrap; flex-shrink:0; margin-left:auto; }\n\n.not-found { padding:40px 0; color:var(--color-text-sec); text-align:center; }\n\n@media (max-width:560px) {\n\t.hero-meta { gap:10px; }\n\t.hero-title-row { gap:12px; }\n\t.hero-meta h2 { font-size:1.05rem; }\n\t.favorite-btn-detail { width:36px; height:36px; font-size:1.1rem; }\n\t.price { font-size:1rem; }\n\t.detail-footer { padding:10px 12px; gap:8px; }\n\t.footer-info { gap:8px; }\n\t.footer-price { font-size:1.1rem; }\n\t.footer-duration { font-size:0.6rem; }\n\t.book-now { padding:10px 16px; font-size:0.85rem; min-width:80px; }\n}\n\n@media (max-width:420px) {\n\t.detail-footer { padding:8px 10px; }\n\t.footer-info { flex-direction:column; gap:2px; align-items:flex-start; }\n\t.footer-price { font-size:1rem; }\n\t.footer-duration { font-size:0.55rem; }\n\t.book-now { padding:8px 12px; font-size:0.8rem; min-width:70px; }\n}\n\n@media (max-width: 360px) {\n  /* 页面整体优化 */\n  .service-detail-page {\n    padding-bottom: 20px; /* 移除底部导航栏空间，详情页面不显示导航栏 */\n  }\n\n  /* 头部区域优化 */\n  .hero {\n    padding: 16px 14px 18px;\n    margin: 10px 0 12px;\n    border-radius: 14px;\n  }\n\n  .hero-image {\n    height: 160px; /* 减少图片高度 */\n    border-radius: 12px;\n  }\n\n  .hero-meta {\n    padding: 14px 0 0;\n  }\n\n  .hero-meta h2 {\n    font-size: 1rem;\n    margin-bottom: 6px;\n  }\n\n  .price {\n    font-size: 0.9rem;\n  }\n\n  /* 内容区域优化 */\n  .content {\n    padding: 16px 14px;\n    margin: 10px 0;\n    border-radius: 14px;\n  }\n\n  .content h3 {\n    font-size: 0.95rem;\n    margin-bottom: 10px;\n  }\n\n  .content p, .content li {\n    font-size: 0.8rem;\n    line-height: 1.5;\n  }\n\n  /* 底部操作栏优化 */\n  .detail-footer {\n    padding: 10px 12px;\n    height: 60px;\n  }\n\n  .footer-info {\n    flex-direction: column;\n    gap: 2px;\n    align-items: flex-start;\n  }\n\n  .footer-price {\n    font-size: 1rem;\n  }\n\n  .footer-duration {\n    font-size: 0.6rem;\n  }\n\n  .book-now {\n    padding: 10px 14px;\n    font-size: 0.8rem;\n    min-width: 70px;\n    min-height: 40px;\n    border-radius: 10px;\n  }\n}\n\n/* 极小屏幕优化 (≤320px) */\n@media (max-width: 320px) {\n  .hero {\n    padding: 14px 12px 16px;\n    margin: 8px 0 10px;\n  }\n\n  .hero-image {\n    height: 140px;\n  }\n\n  .hero-meta h2 {\n    font-size: 0.9rem;\n  }\n\n  .price {\n    font-size: 0.85rem;\n  }\n\n  .content {\n    padding: 14px 12px;\n  }\n\n  .content h3 {\n    font-size: 0.9rem;\n  }\n\n  .content p, .content li {\n    font-size: 0.75rem;\n  }\n\n  .detail-footer {\n    padding: 8px 10px;\n    height: 56px;\n  }\n\n  .footer-price {\n    font-size: 0.9rem;\n  }\n\n  .footer-duration {\n    font-size: 0.55rem;\n  }\n\n  .book-now {\n    padding: 8px 12px;\n    font-size: 0.75rem;\n    min-width: 60px;\n    min-height: 36px;\n  }\n}\n\n/* 预约弹窗样式 */\n.modal-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: rgba(0, 0, 0, 0.5);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index: 1000;\n\tpadding: 20px;\n\tanimation: fadeIn 0.3s ease-out;\n}\n\n.booking-modal {\n\tbackground: var(--color-surface);\n\tborder-radius: 20px;\n\tbox-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n\twidth: 100%;\n\tmax-width: 480px;\n\tmax-height: 90vh;\n\toverflow-y: auto;\n\tanimation: slideUp 0.3s ease-out;\n}\n\n.modal-header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 20px 20px 0;\n\tborder-bottom: 1px solid var(--color-border);\n\tmargin-bottom: 20px;\n}\n\n.modal-header h3 {\n\tmargin: 0;\n\tcolor: var(--color-text);\n\tfont-size: 1.1rem;\n\tfont-weight: 600;\n}\n\n.close-btn {\n\tbackground: none;\n\tborder: none;\n\tfont-size: 24px;\n\tcolor: var(--color-muted);\n\tcursor: pointer;\n\tpadding: 0;\n\twidth: 30px;\n\theight: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n\ttransition: all 0.2s;\n}\n\n.close-btn:hover {\n\tbackground: var(--color-surface-alt);\n\tcolor: var(--color-text);\n}\n\n.modal-body {\n\tpadding: 0 20px 20px;\n}\n\n.form-group {\n\tmargin-bottom: 16px;\n}\n\n.form-group label {\n\tdisplay: block;\n\tmargin-bottom: 6px;\n\tcolor: var(--color-text);\n\tfont-size: 0.9rem;\n\tfont-weight: 500;\n}\n\n.form-group input,\n.form-group textarea {\n\twidth: 100%;\n\tpadding: 12px 14px;\n\tborder: 1px solid var(--color-border);\n\tborder-radius: 12px;\n\tfont-size: 0.9rem;\n\tcolor: var(--color-text);\n\tbackground: var(--color-bg);\n\ttransition: all 0.2s;\n\tbox-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n\toutline: none;\n\tborder-color: var(--color-primary);\n\tbox-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.form-group input:disabled {\n\tbackground: var(--color-surface-alt);\n\tcolor: var(--color-muted);\n\tcursor: not-allowed;\n\topacity: 0.6;\n}\n\n.form-group textarea {\n\tresize: vertical;\n\tmin-height: 80px;\n}\n\n.form-group input.error,\n.form-group textarea.error {\n\tborder-color: var(--color-danger);\n}\n\n.error-text {\n\tdisplay: block;\n\tcolor: var(--color-danger);\n\tfont-size: 0.75rem;\n\tmargin-top: 4px;\n}\n\n.time-hint {\n\tdisplay: block;\n\tcolor: var(--color-muted);\n\tfont-size: 0.75rem;\n\tmargin-top: 4px;\n\tfont-style: italic;\n}\n\n.form-row {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 12px;\n}\n\n.modal-footer {\n\tdisplay: flex;\n\tgap: 12px;\n\tpadding: 20px;\n\tborder-top: 1px solid var(--color-border);\n}\n\n.cancel-btn,\n.confirm-btn {\n\tflex: 1;\n\tpadding: 12px 20px;\n\tborder: none;\n\tborder-radius: 12px;\n\tfont-size: 0.9rem;\n\tfont-weight: 600;\n\tcursor: pointer;\n\ttransition: all 0.2s;\n}\n\n.cancel-btn {\n\tbackground: var(--color-surface-alt);\n\tcolor: var(--color-text-sec);\n\tborder: 1px solid var(--color-border);\n}\n\n.cancel-btn:hover {\n\tbackground: var(--color-border);\n\tcolor: var(--color-text);\n}\n\n.confirm-btn {\n\tbackground: var(--color-primary);\n\tcolor: white;\n}\n\n.confirm-btn:hover {\n\tbackground: var(--color-primary-accent);\n}\n\n@keyframes fadeIn {\n\tfrom { opacity: 0; }\n\tto { opacity: 1; }\n}\n\n@keyframes slideUp {\n\tfrom {\n\t\topacity: 0;\n\t\ttransform: translateY(30px);\n\t}\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateY(0);\n\t}\n}\n\n@media (max-width: 480px) {\n\t.modal-overlay {\n\t\tpadding: 10px;\n\t}\n\t\n\t.booking-modal {\n\t\tmax-height: 95vh;\n\t}\n\t\n\t.form-row {\n\t\tgrid-template-columns: 1fr;\n\t}\n\t\n\t.modal-header,\n\t.modal-body,\n\t.modal-footer {\n\t\tpadding-left: 16px;\n\t\tpadding-right: 16px;\n\t}\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
